import { getEnv } from "@/utils/env";

const LOCAL_ENVIRONMENT = "local";
const DEVELOPMENT_ENVIRONMENT = "dev";
const PRODUCTION_ENVIRONMENT = "prod";

// Environment
export const ENVIRONMENT = getEnv("VITE_ENVIRONMENT");
export const IS_PRODUCTION = ENVIRONMENT === PRODUCTION_ENVIRONMENT;
export const IS_DEVELOPMENT = ENVIRONMENT === DEVELOPMENT_ENVIRONMENT;
export const IS_LOCAL = ENVIRONMENT === LOCAL_ENVIRONMENT;
export const IS_DEBUG = getEnv("VITE_DEBUG") === "true";

// API
export const API_BASE_URL = getEnv("VITE_API_URL", "http://localhost:8081");
export const DISPATCH_WS_URL = getEnv("VITE_DISPATCH_WS_URL", "ws://localhost:8006");

// WorkOS
export const WORKOS_CLIENT_ID = getEnv("VITE_WORKOS_CLIENT_ID");
export const WORKOS_API_HOSTNAME = getEnv("VITE_WORKOS_API_HOSTNAME");
export const WORKOS_REDIRECT_URI = getEnv("VITE_WORKOS_REDIRECT_URI");

// PostHog
export const POSTHOG_KEY = getEnv("VITE_POSTHOG_KEY");
export const POSTHOG_HOST = getEnv("VITE_POSTHOG_HOST");

// Documentation
export const DOCUMENTATION_URL = "https://docs.getgalaxy.io";
export const DOCUMENTATION_QUICKSTART_URL = `${DOCUMENTATION_URL}/quickstart`;
export const DOCUMENTATION_SOURCES_URL = `${DOCUMENTATION_URL}/sources`;
export const DOCUMENTATION_PROJECTS_URL = `${DOCUMENTATION_URL}/projects`;
export const DOCUMENTATION_SETTINGS_URL = `${DOCUMENTATION_URL}/settings`;
export const DOCUMENTATION_PLANS_URL = `${DOCUMENTATION_URL}/usage`;

// Cosmograph
export const COSMOGRAPH_LICENSE_KEY = getEnv("VITE_COSMOGRAPH_LICENSE_KEY");
